import React from "react";
import ReactDOM from "react-dom";
import "./base.css";
import "./index.css";
import "./main.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import setupCustomValidators from "./utils/customValidators";
import App from "./App";
import { Auth0Provider } from "./auth/react-auth0-wrapper";
import history from "./utils/history";
import { initAuthoClient } from "./auth/auth0Client";
import { initInterceptors } from "./api/interceptors";
import EventBus from "./utils/eventBus";

const eventBus = EventBus();

window.Piramis = {
  eventBus
};

initAuthoClient()
  .then(auth0Client => {
    initInterceptors(auth0Client, eventBus);
    // A function that routes the user to the right place
    // after login
    const onRedirectCallback = appState => {
      window.history.replaceState(
        {},
        document.title,
        appState && appState.targetUrl
          ? appState.targetUrl
          : window.location.pathname
      );
    };

    ReactDOM.render(
      <Auth0Provider
        eventBus={eventBus}
        auth0ClientInstance={auth0Client}
        onRedirectCallback={onRedirectCallback}
      >
        <App eventBus={eventBus} />
      </Auth0Provider>,
      document.getElementById("root")
    );
  })
  .catch(error => console.log(error));
